import { Routes } from '../../../../constants/Routes';

type CompleteResult = {
  redirectPath: string;
  fixedId?: string;
  toastMessage: string;
};

export class ProfileUpdateAfter3DSecureStore {
  public async completeAfter3DSecure(): Promise<CompleteResult> {
    const params = new URLSearchParams(window.location.search);
    const encodedUrl = params.get('url');
    const redirectPath = encodedUrl ? decodeURIComponent(encodedUrl) : Routes.Paths.Account;

    return {
      redirectPath,
      toastMessage: '支払方法を更新しました。',
    };
  }
}
